import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "../../../comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

export const BASE = {
    path: `${ptlEnvs.base}/intf/doc`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/intf/doc`,
};

export const URLS = {
    osci0113008q: `${BASE.path}/osci0113008q`, // list
    osci0113009s: `${BASE.path}/osci0113009s`, // regist
    osci0113010s: `${BASE.path}/osci0113010s`, // modification
};

export const APIS = {
    // Get a list of document box. !== 문서함 목록을 조회한다.==!
    getIntfDocMgmtLst: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Get document details. !== 문서함 상세정보 조회 ==!
    getIntfDocInfo: (intfId: any) => {
        return api.get(`${BASE.api}/${intfId}`);
    },
    // Insert document box !== 문서함 등록 ==!
    insertIntfDoc: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // Update Channel !== 채널 수정 ==!
    updateIntfDocInfo: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },
    deleteElctDocBox: (orgEnpoId: any) => api.delete(`${BASE.api}/${orgEnpoId}`),
};

export const SF_INTF_DOC_MGMT_SRCH: TFormSchema = {
    id: "form_intfDocMgmtSrch",
    schema: {
        /* Search keyword Select Option !== 검색어 목록 ==!*/
        kwdSel: {
            type: "select",
            label: "L_KWD",
            options: [
                { label: "L_INTF_NM", value: "A" },
                { label: "L_SNDR_NM", value: "B" },
                { label: "L_RECPT", value: "C" },
                { label: "L_API_URL_ADDR", value: "D" },
            ],
        },
        /* Search keyword Select Option Name !== 검색어 ==!*/
        kwdTxt: {
            type: "text",
            readOnly: true,
        },
        intfId: {
            type: "text",
            label: "L_INTF_ID",
        },
        inexTpCd: {
            type: "select",
            label: "L_INEX_TP_NM",
            all: true,
            area: "comnCd",
            comnCd: "OSC0164",
            excludes: ["CO"],
        },
        actvtYn: {
            type: "select",
            label: "L_ACTVT_YN",
            all: true,
            area: "comnCd",
            comnCd: "OSC0101",
            // defaultValue: "Y"
        },
        sndrcvTpCd: {
            type: "select",
            label: "L_SNDRCV_TP_NM",
            all: true,
            area: "comnCd",
            comnCd: "OSC0104",
        },
        sndrcvDvnCd: {
            type: "select",
            label: "L_SNDRCV_DVN_NM",
            all: true,
            area: "comnCd",
            comnCd: "OSC0109",
        },
    },
};

export const SF_INTF_DOC_MGMT_INFO: TFormSchema = {
    id: "form_intfDocMgmtInfo",
    schema: {
        intfId: { type: "text", label: "L_INTF_ID", required: true, placeholder: "IF-I-COM-001", maxLength: 12 },
        intfNm: { type: "text", label: "L_INTF_NM", required: true },
        sndrNm: { type: "text", label: "L_SNDR_NM", required: true, maxLength: 100 },
        rcvrNm: { type: "text", label: "L_RECPT", required: true, maxLength: 100 },
        sndrSysmNm: { type: "text", label: "L_SEND_SYSM", required: true, maxLength: 100 },
        rcvrSysmNm: { type: "text", label: "L_RCPN_SYSM", required: true, maxLength: 100 },
        rcveEnpoAddr: { type: "text", label: "L_API_URL_ADDR" },
        inpInfoCn: { type: "textarea", label: "L_INP_INFO_CN" },
        otptInfoCn: { type: "textarea", label: "L_OTPT_INFO_CN" },
        inexTpCd: { type: "select", label: "L_INEX_TP_NM", area: "comnCd", comnCd: "OSC0164", required: true },
        sndrcvTpCd: { type: "select", label: "L_SNDRCV_TP_NM", area: "comnCd", comnCd: "OSC0104" },
        lnkgPrtclCd: { type: "select", label: "L_LNKG_PRTCL", area: "comnCd", comnCd: "OSC0105" },
        lnkgDtaTpCd: { type: "select", label: "L_LNKG_DTA_TP", area: "comnCd", comnCd: "OSC0106" },
        prcssMetdCd: { type: "select", label: "L_PRCSS_METD", area: "comnCd", comnCd: "OSC0107" },
        lnkgCycleCd: { type: "select", label: "L_LNKG_CYCLE", area: "comnCd", comnCd: "OSC0108" },
        actvtYn: { type: "radio", label: "L_ACTVT_YN", area: "comnCd", comnCd: "OSC0101", defaultValue: "Y" },
        sndrcvDvnCd: {
            type: "radio",
            label: "L_SNDRCV_DVN_NM",
            area: "comnCd",
            comnCd: "OSC0109",
            required: true,
        },
        lnkgIntfId: { type: "text", label: "L_LNKG_INTF_ID" },
        rspnIntfId: { type: "text", label: "L_RSNP_INTF_ID" },
    },
};

export const SG_INTF_DOC_MGMT_SRCH: TGridSchema = {
    id: "grid_intf_docMgmtSrch",
    options: { pagination: "out", index: true },
    head: [
        {
            cells: [{ header: "L_INTF_ID", binding: "intfId", width: "10%", rowspan: 2 }],
        },
        {
            cells: [{ header: "L_INTF_NM", binding: "intfNm", width: "20%", rowspan: 2 }],
        },
        {
            cells: [
                { header: "L_SNDR_NM", binding: "sndrNm", width: "10%" },
                { header: "L_RECPT", binding: "rcvrNm", width: "10%" },
            ],
        },
        { cells: [{ header: "L_API_URL_ADDR", binding: "rcveEnpoAddr", width: "*", rowspan: 2 }] },
        { cells: [{ header: "L_INEX_TP_NM", binding: "inexTpCd", width: "10%", rowspan: 2 }] },
        {
            cells: [
                { header: "L_SNDRCV_DVN_NM", binding: "sndrcvDvnCd", width: "10%" },
                { header: "L_SNDRCV_TP_NM", binding: "sndrcvTpCd", width: "10%" },
            ],
        },
        { cells: [{ header: "L_ACTVT_YN", binding: "actvtYn", width: "5%", rowspan: 2 }] },
    ],
    body: [
        { cells: [{ binding: "intfId", rowspan: 2 }] },
        { cells: [{ binding: "intfNm", align: "left", rowspan: 2 }] },
        {
            cells: [{ binding: "sndrNm" }, { binding: "rcvrNm" }],
        },
        { cells: [{ binding: "rcveEnpoAddr", align: "left", rowspan: 2 }] },
        {
            cells: [
                {
                    binding: "inexTpCd",
                    type: "select",
                    area: "comnCd",
                    comnCd: "OSC0164",
                    viewType: "label",
                    rowspan: 2,
                },
            ],
        },
        {
            cells: [
                { binding: "sndrcvDvnCd", type: "select", area: "comnCd", comnCd: "OSC0109", viewType: "label" },
                { binding: "sndrcvTpCd", type: "select", area: "comnCd", comnCd: "OSC0104", viewType: "label" },
            ],
        },
        {
            cells: [
                {
                    binding: "actvtYn",
                    type: "select",
                    area: "comnCd",
                    comnCd: "OSC0101",
                    viewType: "label",
                    rowspan: 2,
                },
            ],
        },
    ],
};

export const SG_INTF_ORG_ENPO_LIST: TGridSchema = {
    id: "grid_intfOrgEnpoList",
    options: { checkbox: true },
    head: [
        { cells: [{ header: "L_ORG_ENPO_ID", binding: "orgEnpoId", width: "15%" }] },
        { cells: [{ header: "L_ORG_ENPO_NM", binding: "orgEnpoNm", width: "15%" }] },
        { cells: [{ header: "L_ORG_CD", binding: "orgCd", width: "*" }] },
        { cells: [{ header: "L_ORG_TIN", binding: "orgTin", width: "15%" }] },
        { cells: [{ header: "L_SNDRCV_DVN_NM", binding: "sndrcvDvnCd", width: "10%" }] },
        { cells: [{ header: "L_ORG_ENPO_URL", binding: "orgUrlAddr", width: "*" }] },
        { cells: [{ header: "L_GOVESB_USE_YN", binding: "govesbUseYn", width: "5%" }] },
    ],
    body: [
        { cells: [{ binding: "orgEnpoId" }] },
        { cells: [{ binding: "orgEnpoNm", align: "left" }] },
        { cells: [{ binding: "orgCd", type: "select", area: "orgCd", viewType: "label" }] },
        { cells: [{ binding: "orgTin", align: "left" }] },
        { cells: [{ binding: "sndrcvDvnCd", type: "select", area: "comnCd", comnCd: "OSC0109", viewType: "label" }] },
        { cells: [{ binding: "orgUrlAddr" }] },
        { cells: [{ binding: "govesbUseYn", type: "select", area: "comnCd", comnCd: "OSC0101", viewType: "label" }] },
    ],
};
